<div class="custom-sidenav-container">
    <!-- Sidebar -->
    <div class="custom-sidenav" [class.closed]="!opened" [class.opened]="opened">
        <div class="custom-header">
            <img *ngIf="opened" class="aumico-logo" src="assets/aumico-logo-4c.svg" (click)="toggleSidebar()" />
            <img
                *ngIf="!opened"
                class="aumico-logo"
                src="assets/icons/aumico-logo-small.svg"
                (click)="toggleSidebar()"
            />
            <span
                hamIconShapes
                class="chevron-icon"
                icon="assets/hamIcons/chevron-left.svg"
                [variant]="'transparent'"
                [size]="'xs'"
                (click)="toggleSidebar()"
                *ngIf="opened"
            >
            </span>
        </div>

        <!-- Sidebar Content -->
        <div class="custom-sidenav-content">
            <ng-content select="[sidenav]"></ng-content>
            <div class="separator" *ngIf="opened"></div>
        </div>

        <!-- Footer -->
        <div class="custom-footer">
            <ng-content select="[footer]"></ng-content>
        </div>
    </div>

    <!-- Main Content -->
    <div class="custom-content" [class.sidenav-open]="opened" [class.sidenav-closed]="!opened">
        <div class="custom-main-content">
            <ng-content select="[content]"></ng-content>
        </div>
    </div>
</div>
